module.exports = __webpack_public_path__ + "static/media/slider-right.a67176f6.svg";